import { AxiosResponse } from "axios";
import axiosInstance from "../../../../interceptors/axiosInstance";
import { Archivominvu, ArchivoMinvuDTO, ArgumentosCambiarEstado, ArgumentosUpdateArchivoMinvu, GuardarArchivoDTO } from "../models/cobroSeguros";
import { ListResponseDto } from "../../../../dtos/ListResponseDto";

const BASEURL = "siscred-api-dividendos/v1/minvu/";

const datosArchivos = async (tipoSubsidio: string) => {
    const url = `${BASEURL}obtener-datos-archivo`;
    return axiosInstance.get(url, {
        params: {
            tipoSubsidio: tipoSubsidio
        }
    });
};

const guardarArchivos = async (data: GuardarArchivoDTO) => {
    const url = `${BASEURL}guardar-archivos`;
    return axiosInstance.post(url, data);
};

const cambiarEstado = async (data: ArgumentosCambiarEstado) => {
    const url = `${BASEURL}cambiar-estado-archivo/${data.id}`;
    return axiosInstance.put(url, data);
};


const eliminarArchivo = async (id: number) => {
    const response: AxiosResponse = await axiosInstance.delete(
        `${BASEURL}eliminar-archivo/${id}`,
    );
    return response;
};

const eliminarListadoArchivo = async (data: ArchivoMinvuDTO[]) => {
    const response: AxiosResponse = await axiosInstance.post(
        `${BASEURL}eliminar-listado-archivo`,
        { items: data }
    );
    return response;
};

const actualizarArchivoMinvu = async (data: ArgumentosUpdateArchivoMinvu) => {
    const response: AxiosResponse = await axiosInstance.put(
        `${BASEURL}actualizar-archivo-minvu/${data.id}`,
        data
    );
    return response;
};
const listarArchivosMinvu = async () => {
    const response: AxiosResponse<ListResponseDto<Archivominvu>> = await axiosInstance.get(`${BASEURL}listar-archivos-minvu`);
    return response;
};

const listarArchivoDetalleById = async (id: number) => {
    const response: AxiosResponse<ListResponseDto<ArchivoMinvuDTO>> = await axiosInstance.get(`${BASEURL}listar-archivo-detalle`, {
        params: { id }
    });
    return response;
};

export {
    datosArchivos,
    guardarArchivos,
    cambiarEstado,
    eliminarArchivo,
    eliminarListadoArchivo,
    actualizarArchivoMinvu,
    listarArchivosMinvu,
    listarArchivoDetalleById
};